export const JOB_ALERT_SUBSCRIPTION_FIELDS = {
  EMAIL: "email",
  PHONE: "phone",
} as const;

export const JOB_ALERT_SUBSCRIPTION_MESSAGES = {
  CONTACT_REQUIRED: "Either email or phone is required",
  PHONE_REQUIRED: "Phone is required for WhatsApp alerts",
  EMAIL_REQUIRED: "Email is required for email alerts",
} as const;
